export default {
  namespaced: true,
  state: {
    linkJump: null,
    libCaseJump: '',
    bookCaseJump: '',
    rightBookList: [],
    bookLinkWorkAllList: [],
    bookObj: {
      id: -1,
      baozhiId: 0,
      thumbnail: 'default', // 缩略图地址
      bgMusic: '',
      creator: '',
      title: '',
      shareTitle: '',
      shareDesc: '',
      currentBgUrl: '38',
      currentBgImg: 'template', //背景图分辨是自定义还是官方模板
      lastBg: '',
      soundOn: true, //是否开启音效
      soundId: 0,
      voiceNumber: 1,
      buttonStyle: 1, //图标
      shop: 0,
      buyIcon: 0,
      buyIconType: 1,
      buyLink: '',
      charge: 0,
      chargeIcon: 0,
      chargeIconType: 0,
      pcBuyLinkName: '导购',
      loadingId: 0, //加载页效果 0 默认 1 自定义
      loadingColor: '#df5813',
      ruleForm: {
        //需要校验项
        loadingText: '方正飞翔',
        price: '',
        chargePage: ''
      },
      catalogOn: 1,
      chargeOn: 0,
      catalogList: [],
      catalogId: 0,
      adornment: '', //封面装饰
      logoUrl: '',
      logoUrlOpen: 1,
      newLogoUrl: '',
      fromAlbum: null,
      flip: null,
      posterBg: '',
      openPublic: 0,
      downloadScope: null,
      longPress: 1,
      bookBinding: 0,
      navbarSwtich: 0,
      downloadFormat: '',
      referer: 1, // 页面处理：根据第几页进行自适应
      dpi: 180, // 书刊图片精度
      displayPageNo: 0, //
      open: 1, // 是否公开展示
      category: null, // 书刊种类： 0 期刊 1 报纸
      audioData: {}, // 播放音效数据
      questionnaire: 0, // 问卷开关 0=关闭，1=开启 默认0
      questionType: 0, //问卷来源 0=云阅读问卷，1=外链问卷
      // questionContent: [], // 问卷来源为云阅读时：{"formName":"问卷名称","construction":"问卷表单结构"} ；外链问卷时为外链地址
      // questionContent 保存时，用该字段，回显时分为questionContent和questionContentLink
      questionContent: {},
      questionContentConstruction: [],
      questionContentLink: null, // 外链问卷
      questionIconType: 0,
      pcQuestionName: '问卷',
      questionIcon: 0, // 0 问卷、1 留言反馈、2 采购、3 在线投稿、4 报名
      officialWeb: 0,
      homePageUrl: '',
      homePageTitle: '',
      historyResource: 0,
      entryName: '',
      entryUrl: '',
      displayOrNot: { login: 1, collect: 1, thumbnail: 1, catalog: 1, search: 1, share: 1, help: 1, searchArticle: 1, tingWen: 1 }, //功能显示隐藏设置
      colorSwitch: 0,
      colorContent: { 'top-nav': '#FFFFFF', 'top-txt': '#000000', 'top-icon': 1, 'mobile-nav': '#3A3A3A', 'mobile-txt': '#FFFFFF', 'mobile-icon': 0 },
      language: 0,
      listenStyle: 0,
      voiceSpeed: 0,
      sentenceRead: 0,
      copyText: 1
    },
    paperStyle: '', // 报纸样式
    bookShelfObj: {
      // 专辑
      id: -1,
      style: 0, // 木纹样式
      openMode: 0, // 打开方式 0-直接打开，1-新标签打开，默认0
      title: '', //专辑名称
      thumbnail: 'default', // 缩略图地址
      shareTitle: '', //专辑分享标题设置
      shareDesc: '',
      chooseBookList: [],
      allBookList: [],
      albumId: '', //专辑id
      bookIds: [], //书刊id
      albumData: [],
      customTit: '',
      selPoster: 0,
      isPoster: 0,
      cusImg: '',
      relevanceText: '',
      charge: 0,
      chargeIcon: 0,
      questionnaire: 0, // 问卷开关 0=关闭，1=开启 默认0
      questionType: 0, //问卷来源 0=云阅读问卷，1=外链问卷
      questionContent: {},
      questionContentConstruction: [],
      questionContentLink: null, // 外链问卷
      displayOrNot: { login: 1, collect: 1, search: 1, share: 1, pctitle: 0, hoverQRcode: 1 }, //功能显示隐藏设置
      coverOption: 0, // 封面选项,0-最新上传作品封面,1-自定义专辑封面
      cover: '', //自定义封面地址
      language: 0
    },
    bookLibObj: {
      libId: '',
      style: 0, // 木纹样式
      openMode: 0,
      title: '', //专辑名称
      thumbnail: 'default', // 缩略图地址
      shareTitle: '', //专辑分享标题设置
      shareDesc: '',
      chooseBookList: [],
      allBookList: [],
      ids: [], //书刊专辑id
      customTit: '',
      selPoster: 0,
      isPoster: 0,
      cusImg: '',
      questionnaire: 0, // 问卷开关 0=关闭，1=开启 默认0
      questionType: 0, //问卷来源 0=云阅读问卷，1=外链问卷
      questionContent: {},
      questionContentConstruction: [],
      questionContentLink: null, // 外链问卷
      displayOrNot: { login: 1, collect: 1, search: 1, share: 1, pctitle: 0, hoverQRcode: 1 }, //功能显示隐藏设置
      language: 0
    },
    logoThumbnail: '', //logo缩略图地址
    pcLogo: '',
    logo: {
      newLogoThumbnail: '' //给logo赋值的值
    },
    book: {
      loadingPic: ''
    },
    poster: {
      poster: '',
      posterBg: '',
      posterSelSty: 0,
      book: {
        posterQrCodeShow: 1,
        posterNameShow: 1,
        posterName: '',
        posterTextShow: 1,
        posterPromptText: '微信识别二维码',
        posterCover: ['', '']
      },
      album: {
        posterQrCodeShow: 1,
        posterNameShow: 1,
        posterName: '',
        posterTextShow: 1,
        posterPromptText: '微信识别二维码',
        posterCover: ['', '']
      },
      lib: {
        posterQrCodeShow: 1,
        posterNameShow: 1,
        posterName: '',
        posterTextShow: 1,
        posterPromptText: '微信识别二维码',
        posterCover: ['', '']
      }
    },
    bookShelfLogo: {
      logo: ''
    },
    bookLibLogo: {
      logo: ''
    },
    allDownload: false,
    questionairePublishedFlag: false, //标识用户是否点击过发布问卷，只有点击过时，问卷内容才传给后端，否则传空
    xiaoYangData: null,
    isPublish: false,
    languageOptions: [
      {
        search: '搜索',
        pleaseEnterKeywords: '请输入关键字',
        notice: '提示',
        searchTip: '至少输入两个关键字',
        confirm: '确定',
        cancel: '取消',
        help: '帮助',
        searchResultTip: function(val) {
          return '总共找到' + val + '条结果'
        },
        pageNumTip: function(val) {
          return '第 ' + val + ' 页'
        },
        operationGuide: [
          '鼠标双击',
          '1.原始版面下，双击鼠标开始缩放模式',
          '2.缩放模式下，双击鼠标退出缩放模式',
          '滑动鼠标滚轮',
          '1.原始版面下可实现翻页',
          '2.缩放模式下，可用于调节书刊显示比例，展示书刊细节',
          '我已了解',
          '您可通过下方操作栏解锁更多实用技能'
        ],
        zoomIn: '放大',
        zoomOut: '缩小',
        fullScreen: '全屏',
        share: '分享',
        loginRegistration: '登录/注册',
        myHomepage: '我的主页',
        thumbnail: '缩略图',
        contents: '目录',
        firstPage: '首页',
        previousPage: '上一页',
        pageN: function(val) {
          return `第 ${val} 页, 跳至 `
        },
        turnToPageN: '跳至 N',
        nextPage: '下一页',
        lastPage: '尾页',
        autoPageTurning: '自动翻页',
        sound: '声音',
        download: '下载',
        textMode: '流式阅读',
        article: '文章',
        more: '更多',
        listeningMode: '听文章',
        noDataAvailable: '暂无数据',
        sharePublication: '分享书刊',
        scanQrCodeMobileReading: '扫描二维码 手机端阅读',
        downloadQrCode: '下载二维码',
        poster: '海报',
        generatePoster: '生成海报',
        copyLink: '复制链接',
        copyIFrameCode: '复制嵌入代码',
        scenarios: '适用场景',
        size: '尺寸',
        operation: '操作',
        downloadPosterImages: '下载海报图片',
        fileDownload: '文件下载',
        soundControl: '声音控制',
        pageTurningSound: '翻书声音',
        backgroundMusic: '背景音乐',
        on: '开启',
        off: '关闭',
        searchByTitle: '请输入书名搜索',
        favorites: '收藏',
        collected: '已收藏',
        name: '名称',
        time: '时间',
        subscription: '订阅',
        subscribed: '已订阅',
        questionnaire: '问卷',
        shareCollection: function(val) {
          return `分享${val}`
        },
        shareCollectionTip: function(val) {
          return `扫描上方二维码，将你的${val}分享给他人`
        },
        switchPublications: '切换刊物',
        viewCover: '查看封面',
        viewList: '查看列表',
        subscribedTip: '您已订阅本书',
        addedToFavorites: '收藏成功',
        unsubscribed: '取消收藏成功',
        thisIsTheFirstPage: '这是第一页',
        thisIsTheLastPage: '这是最后一页',
        price: '订购价格',
        validity: '阅读期限',
        permanent: '永久有效',
        nMonths: ' 个月',
        subscribeNow: '立即订阅',
        addToFavorites: '先加收藏',
        welcomeToSubscribe: '欢迎订阅',
        orderNumber: '订单号',
        orderPrice: '订单金额',
        paymentTip: '选择支付方式',
        goToPayment: '去付款',
        lock: '固定',
        unlock: '取消固定',
        loading: '正在加载中...',
        viewDetailsTip: '双手缩放，查看细节',
        pageTurningTip: '左右滑动，前后翻页',
        turnPage: '翻页',
        confirmUnderstood: '我已了解',
        searchAll: '全站搜索',
        unFullScreen: '取消全屏',
        officialWeb: '官方主页',
        wechat: '微信',
        link: '链接'
      },
      {
        search: 'Search',
        pleaseEnterKeywords: 'Please enter keywords',
        notice: 'Notice',
        searchTip: 'Enter at least two words for keywords',
        confirm: 'Confirm',
        cancel: 'Cancel',
        help: 'Help',
        searchResultTip: function(val) {
          return val + ' results were found'
        },
        pageNumTip: function(val) {
          return 'Page ' + val
        },
        operationGuide: [
          'Double click.',
          '1. When viewing the original layout, double click to enter zoom mode.',
          '2. When in zoom mode, double click to exit.',
          'Scroll with the mouse wheel.',
          '1. When viewing the original layout, use the mouse wheel to flip pages.',
          '2. In zoom mode, use the mouse wheel to adjust the display ratio of books and periodicals and view details.',
          'Confirm',
          'Check the operation bar below for more functions.'
        ],
        zoomIn: 'Zoom in',
        zoomOut: 'Zoom out',
        fullScreen: 'Full screen',
        share: 'Share',
        loginRegistration: 'Login/Registration',
        myHomepage: 'My Homepage',
        thumbnail: 'Thumbnail',
        contents: 'Contents',
        firstPage: 'First page',
        previousPage: 'Previous page',
        pageN: function(val) {
          return `Page ${val}, Turning to Page `
        },
        turnToPageN: 'Turning to Page N',
        nextPage: 'Next page',
        lastPage: 'Last page',
        autoPageTurning: 'Auto page turning',
        sound: 'Sound',
        download: 'Download',
        textMode: 'Text mode',
        article: 'Article',
        more: 'More',
        listeningMode: 'Listening mode',
        noDataAvailable: 'No data available',
        sharePublication: 'Share publication',
        scanQrCodeMobileReading: 'Scan QR code for mobile reading',
        downloadQrCode: 'Download QR code',
        poster: 'Poster',
        generatePoster: 'Generate poster',
        copyLink: 'Copy link',
        copyIFrameCode: 'Copy iFrame code',
        scenarios: 'Scenarios',
        size: 'Size',
        operation: 'Operation',
        downloadPosterImages: 'Download poster images',
        fileDownload: 'File download',
        soundControl: 'Sound control',
        pageTurningSound: 'Page turning sound',
        backgroundMusic: 'Background music',
        on: 'On',
        off: 'Off',
        searchByTitle: 'Search for books by title',
        favorites: 'Favorites',
        collected: 'Collected',
        name: 'Name',
        time: 'Time',
        subscription: 'Subscription',
        subscribed: 'Subscribed',
        questionnaire: 'Questionnaire',
        shareCollection: function(val) {
          return `Share ${val}`
        },
        shareCollectionTip: function(val) {
          return `Scan the QR code above to share your ${val}`
        },
        switchPublications: 'Switch publications',
        viewCover: 'Cover',
        viewList: 'List',
        subscribedTip: 'You have subscribed to this book',
        addedToFavorites: 'Added',
        unsubscribed: 'Cancelled',
        thisIsTheFirstPage: 'This is the first page',
        thisIsTheLastPage: 'This is the last page',
        price: 'Price',
        validity: 'Validity',
        permanent: 'Permanent',
        nMonths: ' months',
        subscribeNow: 'Subscribe now',
        addToFavorites: 'Add to favorites',
        welcomeToSubscribe: 'Welcome to subscribe',
        orderNumber: 'Order number',
        orderPrice: 'Price',
        paymentTip: 'Select payment method',
        goToPayment: 'Payment',
        lock: 'Lock',
        unlock: 'Unlock',
        loading: 'Loading...',
        viewDetailsTip: 'Zoom in to view details',
        pageTurningTip: 'Slide for page turning',
        turnPage: 'Page',
        confirmUnderstood: 'Confirm',
        searchAll: 'Search All',
        unFullScreen: 'Cancel full screen',
        officialWeb: 'Official website',
        wechat: 'WeChat',
        link: 'Link'
      }
    ]
  },
  mutations: {
    UPDATE_BOOK_ITEM(state, option) {
      state.bookObj[option.name] = option.val
    },
    LIB_CASE_JUMP(state, data) {
      state.libCaseJump = data
    },
    BOOK_CASE_JUMP(state, data) {
      state.bookCaseJump = data
    },
    LINK_JUMP(state, data) {
      state.linkJump = data
    },
    BOOK_LINK_WORK_ALL_LIST(state, data) {
      state.bookLinkWorkAllList = data
    },
    RIGHT_BOOK_LIST(state, data) {
      state.rightBookList = data
    },

    UPDATE_BOOKOBJ(state, data) {
      state.bookObj = {
        ...state.bookObj,
        ...data
      }
    },
    UPDATE_BOOK_ID(state, id) {
      state.bookObj.id = id
    },
    UPDATE_BAOZHIID(state, baozhiId) {
      state.bookObj.baozhiId = baozhiId
    },
    UPDATE_THUMBNAIL(state, url) {
      state.bookObj.thumbnail = url
    },
    UPDATE_BGMUSIC(state, bgMusic) {
      state.bookObj.bgMusic = bgMusic
    },
    UPDATE_TITLE_MESSAGE(state, shareTitle) {
      state.bookObj.shareTitle = shareTitle
    },
    UPDATE_TITLE_DESC(state, shareDesc) {
      state.bookObj.shareDesc = shareDesc
    },
    UPDATE_CURRENT_BG(state, bgUrl) {
      state.bookObj.currentBgUrl = bgUrl
    },
    UPDATE_CURRENT_BGIMG(state, bgImg) {
      state.bookObj.currentBgImg = bgImg
    },
    UPDATE_SOUND(state, sound) {
      state.bookObj.soundOn = sound
    },
    UPDATE_SOUND_ID(state, id) {
      state.bookObj.soundId = id
    },
    UPDATE_VOICE_NUMBER(state, id) {
      state.bookObj.voiceNumber = id
    },
    //
    UPDATE_BUTTON(state, id) {
      state.bookObj.buttonStyle = id
    },
    UPDATE_PAPERSTYLE(state, style) {
      state.paperStyle = style
    },
    CHARGE(state, setting) {
      state[setting.type].charge = setting.value
    },
    CHARGE_ICON(state, setting) {
      state[setting.type].chargeIcon = setting.value
    },
    CHARGE_ICON_TYPE(state, id) {
      if (!isNaN(id)) {
        state.bookObj.chargeIconType = id
      }
    },
    PCBUY_LINKNAME(state, name) {
      state.bookObj.pcBuyLinkName = name
    },
    SHOP(state, id) {
      state.bookObj.shop = id
    },
    BUY_ICON(state, buyIcon) {
      state.bookObj.buyIcon = buyIcon
    },
    BUY_ICON_TYPE(state, buyIconType) {
      state.bookObj.buyIconType = buyIconType
    },
    //
    UPDATE_LOADING_ID(state, id) {
      state.bookObj.loadingId = id
    },
    UPDATE_RULE_FORM(state, text) {
      state.bookObj.ruleForm = text
    },
    UPDATE_LOADING_COLOR(state, color) {
      state.bookObj.loadingColor = color
    },
    UPDATE_CATALOG_ID(state, id) {
      state.bookObj.catalogId = id
    },
    UPDATE_CATALOG_LIST(state, list) {
      state.bookObj.catalogList = list
    },

    BUY_LINK(state, list) {
      state.bookObj.buyLink = list
    },

    UPDATE_ADORNMENT(state, adornment) {
      state.bookObj.adornment = adornment
    },
    UPDATE_LOGOTHUMBNAIL(state, logoThumbnail) {
      state.logoThumbnail = logoThumbnail
    },
    UPDATE_PCLOGO(state, pcLogo) {
      state.pcLogo = pcLogo
    },
    UPDATE_XIAOYANGLIST(state, xiaoYangData) {
      state.xiaoYangData = xiaoYangData
    },
    UPDATE_NEWLOGOTHUMBNAIL(state, newLogoThumbnail) {
      state.logo.newLogoThumbnail = newLogoThumbnail
    },
    UPDATE_LOADINGPIC(state, loadingPic) {
      state.book.loadingPic = loadingPic
    },
    UPDATE_FLIP(state, flip) {
      state.bookObj.flip = flip
    },
    UPDATE_LOGOURL(state, logoUrl) {
      state.bookObj.logoUrl = logoUrl
    },
    UPDATE_LOGOURL_OPEN(state, logoUrlOpen) {
      if (logoUrlOpen == 1 || logoUrlOpen == 0) {
        state.bookObj.logoUrlOpen = logoUrlOpen
      }
    },
    UPDATE_LONG_PRESS(state, longPress) {
      if (longPress == 1 || longPress == 0) {
        state.bookObj.longPress = longPress
      } else {
        state.bookObj.longPress = 1
      }
    },
    UPDATE_BOOKBINDING(state, bookBinding) {
      state.bookObj.bookBinding = bookBinding
    },
    UPDATE_NAVBAR_SWITCH(state, navbarSwtich) {
      if (navbarSwtich == 1 || navbarSwtich == 0) {
        state.bookObj.navbarSwtich = navbarSwtich
      } else {
        state.bookObj.navbarSwtich = 0
      }
    },
    UPDATE_NEWLOGOURL(state, logoUrl) {
      state.bookObj.newLogoUrl = logoUrl
    },
    UPDATE_FROMALBUM(state, fromAlbum) {
      state.bookObj.fromAlbum = fromAlbum
    },
    UPDATE_COLOR_SWITCH(state, colorSwitch) {
      state.bookObj.colorSwitch = colorSwitch
    },
    UPDATE_COLOR_CONTENT(state, colorContent) {
      state.bookObj.colorContent = colorContent
    },
    UPDATE_COLOR_CONTENT_ITEM(state, colorContent) {
      state.bookObj.colorContent[colorContent.name] = colorContent.value
    },
    UPDATE_POSTER(state, poster) {
      state.poster.poster = poster
    },
    UPDATE_POSTERBG(state, posterBg) {
      state.poster.posterBg = posterBg
    },
    UPDATE_POSTERSELECTSTYLE(state, posterSelSty) {
      state.poster.posterSelSty = posterSelSty
    },
    UPDATE_POSTERBOOK(state, book) {
      state.poster.book.posterQrCodeShow = book.posterQrCodeShow
      state.poster.book.posterNameShow = book.posterNameShow
      state.poster.book.posterName = book.posterName
      state.poster.book.posterTextShow = book.posterTextShow
      state.poster.book.posterPromptText = book.posterPromptText
      state.poster.book.posterCover[0] = book.posterCover[0]
      state.poster.book.posterCover[1] = book.posterCover[1]
    },
    UPDATE_POSTERALBUM(state, album) {
      state.poster.album.posterQrCodeShow = album.posterQrCodeShow
      state.poster.album.posterNameShow = album.posterNameShow
      state.poster.album.posterName = album.posterName
      state.poster.album.posterTextShow = album.posterTextShow
      state.poster.album.posterPromptText = album.posterPromptText
      state.poster.album.posterCover[0] = album.posterCover[0]
      state.poster.album.posterCover[1] = album.posterCover[1]
    },
    UPDATE_POSTERLIB(state, lib) {
      state.poster.lib.posterQrCodeShow = lib.posterQrCodeShow
      state.poster.lib.posterNameShow = lib.posterNameShow
      state.poster.lib.posterName = lib.posterName
      state.poster.lib.posterTextShow = lib.posterTextShow
      state.poster.lib.posterPromptText = lib.posterPromptText
      state.poster.lib.posterCover[0] = lib.posterCover[0]
      state.poster.lib.posterCover[1] = lib.posterCover[1]
    },
    UPDATE_OPENPUBLIC(state, openPublic) {
      state.bookObj.openPublic = openPublic
    },
    UPDATE_DOWNLOADSCOPE(state, downloadScope) {
      state.bookObj.downloadScope = downloadScope
    },
    UPDATE_DOWNLOADFORMAT(state, downloadFormat) {
      state.bookObj.downloadFormat = downloadFormat
    },
    UPDATE_ALLDOWNLOAD(state, allDownload) {
      state.allDownload = allDownload
    },
    UPDATE_AUDIODATA(state, audioData) {
      state.bookObj.audioData = {
        ...audioData
      }
    },
    // 书架编辑
    // 更新当前编辑的书架对象
    UPDATE_BOOKSHELFOBJ(state, data) {
      state.bookShelfObj = {
        ...state.bookShelfObj,
        ...data
      }
    },
    UPDATE_OBJ_LANGUAGE(state, data) {
      state[data.type].language = data.value
    },
    // 更新当前编辑的书架id
    UPDATE_BOOKSHELF_ID(state, id) {
      state.bookShelfObj.id = id
    },
    // 更新当前编辑的书架分享缩略图
    UPDATE_BOOKSHELFTHUMBNAIL(state, url) {
      state.bookShelfObj.thumbnail = url
    },
    // 更新当前编辑的书架分享标题
    UPDATE_BOOKSHELFTITLE_MESSAGE(state, shareTitle) {
      state.bookShelfObj.shareTitle = shareTitle
    },
    // 更新当前编辑的书架专辑名称
    UPDATE_BOOKSHELFTITLE_TITLE(state, title) {
      state.bookShelfObj.title = title
    },
    // 更新专辑木纹样式
    UPDATE_BOOKSHELFSTYLE(state, shareDesc) {
      state.bookShelfObj.style = shareDesc
    },
    UPDATE_BOOKSHELFOPENMODE(state, shareDesc) {
      state.bookShelfObj.openMode = shareDesc
    },

    // 更新当前编辑的书架分享描述
    UPDATE_BOOKSHELFTITLE_DESC(state, shareDesc) {
      state.bookShelfObj.shareDesc = shareDesc
    },
    // 更新当前编辑的书架已选书刊
    UPDATE_BOOKSHELFTITLE_CHOSEBOOKLIST(state, list) {
      state.bookShelfObj.chooseBookList = list
    },
    // 更新当前编辑的书架所有书刊
    UPDATE_BOOKSHELFTITLE_ALLBOOKLIST(state, list) {
      state.bookShelfObj.allBookList = list
    },
    // 储存专辑里面书刊id
    UPDATE_BOOKSHELF_BOOKIDS(state, ids) {
      state.bookShelfObj.bookIds = ids
    },
    //更新专辑id
    UPDATE_ALBUMID(state, albumId) {
      state.bookShelfObj.albumId = albumId
    },
    // 更新专辑数量
    UPDATE_ALBUMDATA(state, albumData) {
      state.bookShelfObj.albumData = albumData
    },
    UPDATE_BOOKSHELFISPOSTER(state, isPoster) {
      state.bookShelfObj.isPoster = isPoster
    },
    UPDATE_BOOKSHELFSELPOSTER(state, selPoster) {
      state.bookShelfObj.selPoster = selPoster
    },
    UPDATE_BOOKSHELFCUSTOMTIT(state, customTit) {
      state.bookShelfObj.customTit = customTit
    },
    UPDATE_BOOKSHELFCUSIMG(state, cusImg) {
      state.bookShelfObj.cusImg = cusImg
    },
    UPDATE_BOOKSHELFRELEVANCETEXT(state, relevanceText) {
      state.bookShelfObj.relevanceText = relevanceText
    },
    UPDATE_BOOKSHELFLOGO(state, logo) {
      state.bookShelfLogo.logo = logo
    },
    // 更新当前编辑的书架对象
    UPDATE_BOOKLIBOBJ(state, data) {
      state.bookLibObj = {
        ...state.bookLibObj,
        ...data
      }
    },
    // 图书馆编辑
    UPDATE_BOOKLIBLOGO(state, logo) {
      state.bookLibLogo.logo = logo
    },
    // 更新图书馆木纹样式
    UPDATE_BOOKLIBSTYLE(state, shareDesc) {
      state.bookLibObj.style = shareDesc
    },
    UPDATE_BOOKLIBOPENMODE(state, shareDesc) {
      state.bookLibObj.openMode = shareDesc
    },

    // 更新图书馆的分享缩略图
    UPDATE_BOOKLIBTHUMBNAIL(state, url) {
      state.bookLibObj.thumbnail = url
    },
    // 更新图书馆的分享标题
    UPDATE_BOOKLIBTITLE_MESSAGE(state, shareTitle) {
      state.bookLibObj.shareTitle = shareTitle
    },
    // 更新图书馆的专辑名称
    UPDATE_BOOKLIBTITLE_TITLE(state, title) {
      state.bookLibObj.title = title
    },
    // 更新图书馆的分享描述
    UPDATE_BOOKLIBTITLE_DESC(state, shareDesc) {
      state.bookLibObj.shareDesc = shareDesc
    },
    // 更新当前图书馆的已选书刊专辑
    UPDATE_BOOKLIBTITLE_CHOSEBOOKLIST(state, list) {
      state.bookLibObj.chooseBookList = list
    },
    // 更新当前图书馆所有书刊专辑
    UPDATE_BOOKLIBTITLE_ALLBOOKLIST(state, list) {
      state.bookLibObj.allBookList = list
    },
    UPDATE_BOOKSLIB_IDS(state, ids) {
      state.bookLibObj.ids = ids
    },
    UPDATE_BOOKLIBISPOSTER(state, isPoster) {
      state.bookLibObj.isPoster = isPoster
    },
    UPDATE_BOOKLIBSELPOSTER(state, selPoster) {
      state.bookLibObj.selPoster = selPoster
    },
    UPDATE_BOOKLIBCUSTOMTIT(state, customTit) {
      state.bookLibObj.customTit = customTit
    },
    UPDATE_BOOKLIBCUSIMG(state, cusImg) {
      state.bookLibObj.cusImg = cusImg
    },
    // 参数设置
    UPDATE_ADDITIONAL_SETTING(state, setting) {
      state.bookObj.open = setting.open
      state.bookObj.referer = setting.referer
      state.bookObj.dpi = Number(setting.dpi)
      state.bookObj.displayPageNo = Number(setting.displayPageNo)
    },
    UPDATE_DPI(state, dpi) {
      state.bookObj.dpi = Number(dpi)
    },
    // 设置按钮显示
    UPDATE_DISPLAY_OR_NOT(state, val) {
      state.bookObj.displayOrNot = {
        ...state.bookObj.displayOrNot,
        ...val
      }
    },
    // 设置书架按钮显示
    UPDATE_DISPLAY_OR_NOT_SHELF(state, val) {
      state[val.type].displayOrNot = {
        ...state[val.type].displayOrNot,
        ...val.displayOrNot
      }
    },
    // 设置问卷内容
    UPDATE_QUESTIONAIRE(state, setting) {
      state[setting.type][setting.key] = setting.value
    },
    // 设置问卷是否发布标识
    UPDATE_QUESTIONAIRE_FLAG(state, flag) {
      state.questionairePublishedFlag = flag
    },
    // 设置问卷是否发布标识
    UPDATE_IS_PUBLISH(state, flag) {
      state.isPublish = flag
    },
    //自定义封面
    UPDATE_COVER(state, setting) {
      state[setting.type][setting.key] = setting.value
    },
    PCQUESTION_NAME(state, value) {
      state.bookObj.pcQuestionName = value
    },
    UPDATE_OFFICIALWEB(state, value) {
      state.bookObj.officialWeb = value
    },
    UPDATE_HOMEPAGE_TITLE(state, value) {
      state.bookObj.homePageTitle = value
    },
    UPDATE_HOMEPAGE_URL(state, value) {
      state.bookObj.homePageUrl = value
    },
    UPDATE_HISTORY_RESOURCE(state, value) {
      state.bookObj.historyResource = value
    },
    UPDATE_ENTRY_NAME(state, value) {
      state.bookObj.entryName = value
    },
    UPDATE_ENTRY_URL(state, value) {
      state.bookObj.entryUrl = value
    },
    UPDATE_LANGUAGE(state, language) {
      state.bookObj.language = language
    }
  }
}
